import { StyledButton } from 'src/assets/styles/components/Button';

const Button = (props) => {
  const { text, disabled, onClick, type, tag } = props;
  return (
    <StyledButton
      type={type || 'button'}
      disabled={disabled}
      onClick={onClick}
      className={tag ? 'Button--tag' : undefined}
    >
      {text}
    </StyledButton>
  );
};

export default Button;
